module.exports = __webpack_public_path__ + "img/lens-174-minus-04.9eaaa2c4.png";